import React, { useEffect, useState } from "react";
import Profile from "../../assets/images/Profile.svg";
import { Card, Form, Table, Modal, Button } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import VisaVerifiedGrey from "../../assets/images/verifyTrades/VisaVerifiedGrey.svg";
import threeDSecureIcon from "../../assets/images/verifyTrades/3dSecureIcon.svg";
import MasterCardSecureCod from "../../assets/images/MasterCardIcon.svg";
import stripeIcon from "../../assets/images/verifyTrades/stripeIcon.svg";
import discountIcon from "../../assets/images/verifyTrades/discountIcon.svg";
import cross from "../../assets/images/cross.svg";
import tradeBellPng from "../../assets/images/bellIcon.svg";
import "./VerifyMyTradePayment.css";
import useApi from "../../helpers/apiHelper/requestHelper";
import GenericTable from "../sharedPages/CommonComponents/Table/index";
import BubbleSvgButton from "../sharedPages/CommonComponents/BubbleSvgButton/BubbleSvgButton";
import { showNotificationToast, toastify } from "../../helpers/toast/toastify";
import {
  selectedRowsforVerifyMyTrade,
  paymentTypeAtom,
} from "../../store/globalstore";
import { useAtom } from "jotai";
import { useSelector, useDispatch } from "react-redux";
import {
  EmbeddedCheckoutProvider,
  EmbeddedCheckout,
} from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { setRefetchSpecificUser } from "../../redux/multicommunity/multicommunity";
import { fetchUser, getFutureDate } from "../../helpers/helper";
import { storeUser } from "../../redux/users/usersSlice";
import VerificationApiModal from "../sharedPages/NewCopyTrade/ExchangeConnection/VerificationApiModal";
import greenCheck from "../../assets/images/greenCheck.svg";
import {
  generateDummyClosedTrades,
  generateDummyLiveTrades,
} from "./dummyDataGeneration";
import VerifyMyTradesTable from "./VerifyMyTradesTabLe";
import DashboardMarketSelect from "../sharedPages/CommonComponents/DashboardMarketSelect/DashboardMarketSelect";
import { useDashboardMarket } from "../sharedPages/CommonComponents/DashboardMarketSelect/DashboardMarketContext";
import "../sharedPages/CommonComponents/DashboardMarketSelect/DashboardMarketSelect.css";

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_KEY);

const getMarketTypeParam = (marketKey) =>
  marketKey === "spot" ? "spot" : "futures";

const monthlyPricingOptions = [
  {
    id: "option1",
    price: `$9.95<span>/ month</span>`,
    description: "Performance updated monthly on the blockchain.",
    planType: "monthly-blockchain-monthly",
    storing: "Monthly storing",
    numericPrice: 9.95,
  },
  {
    id: "option2",
    price: `$19.95<span>/ month</span></span>`,
    description: "Performance updated daily on the blockchain.",
    planType: "monthly-blockchain-daily",
    storing: "Daily storing",
    numericPrice: 19.95,
  },
];

const yearlyPricingOptions = [
  {
    id: "option1",
    price: `$99.95<span>/ year</span>`,
    description: "Performance updated monthly on the blockchain for a year.",
    planType: "yearly-blockchain-monthly",
    storing: "Monthly storing",
    numericPrice: 99.95,
  },
  {
    id: "option2",
    price: `$199.95<span>/ year</span>`,
    description: "Performance updated daily on the blockchain for a year.",
    planType: "yearly-blockchain-daily",
    storing: "Daily storing",
    numericPrice: 199.95,
  },
];

const performanceDescrp = [
  "Performance stored on-chain",
  "Verifiable on blockchain & website",
  "Auto-shared to social",
];

const VerifyMyTradePayment = ({
  setPaymentStarted,
  showTable,
  setShowTable,
}) => {
  const user = useSelector((state) => state?.user?.user);
  const [activeButton, setActiveButton] = useState("");

  const [tableData, setTableData] = useState([]);
  const [liveTableData, setLiveTableData] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [clientSecret, setClientSecret] = useState("");
  const [selectedPlanType, setSelectedPlanType] = useState("");
  const [selectedRowsForStatsCalculation, setSelectedRowsForStatsCalculation] =
    useAtom(selectedRowsforVerifyMyTrade);
  const [paymentprocessing, setPaymentprocessing] = useState(false);
  const [loading, setLoading] = useState(false);
  const [cancelLoading, setCancelLoading] = useState(false);

  // State for confirmation modal
  const [showConfirmation, setShowConfirmation] = useState({
    show: false,
    action: "", // "Cancel", "Upgrade", "Downgrade", "Subscribe", "Reactivate"
  });
  const [pendingPlan, setPendingPlan] = useState(null);

  const [paymentType, setPaymentType] = useAtom(paymentTypeAtom);
  const [subscribed, setSubscribed] = useState(false);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const api = useApi();
  const itemsPerPage = 5;
  const { selectedMarket, permissionType } = useDashboardMarket();
  const canShowSpotOpenTrades =
    permissionType === "spot" || permissionType === "both";
  const canShowFuturesOpenTrades =
    permissionType === "futures" || permissionType === "both";
  const canShowOpenTrades =
    selectedMarket === "spot"
      ? canShowSpotOpenTrades
      : canShowFuturesOpenTrades;
  const selectedMarketLabel = selectedMarket === "spot" ? "spot" : "futures";

  const call1TimeApi = async (market = selectedMarket) => {
    const marketType = getMarketTypeParam(market);
    const response = await api(
      "post",
      `binanceCredentials/userTrades?marketType=${marketType}`
    );
    const trades = (response?.data?.trades || []).sort(
      (a, b) => new Date(b.timestamp) - new Date(a.timestamp)
    );
    setTableData(trades);
  };

  const handleRowSelect = (rowData, rowIndex) => {
    const isSelected = selectedRows.includes(rowData?._id);

    if (isSelected) {
      setSelectedRows(selectedRows.filter((id) => id !== rowData?._id));
      setSelectedRowsForStatsCalculation((prev) => {
        const updated = prev.filter((item) => item.id !== rowData?._id);
        return updated;
      });
    } else {
      setSelectedRows([...selectedRows, rowData?._id]);
      setSelectedRowsForStatsCalculation((prev) => {
        const updated = [...prev, rowData];
        return updated;
      });
    }
  };

  const handleSelectAll = (selectAll) => {
    if (selectAll) {
      const allRowIds = formattedData.map((row) => row.id);
      setSelectedRows(allRowIds);
      setSelectedRowsForStatsCalculation(formattedData);
    } else {
      setSelectedRows([]);
      setSelectedRowsForStatsCalculation([]);
    }
  };

  useEffect(() => {
    if (activeButton === "One Time" && showTable === "closed") {
      call1TimeApi(selectedMarket);
    }
    setCurrentPage(1);
    setSelectedPlanType("");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeButton, selectedMarket, showTable]);

  useEffect(() => {
    setSelectedRows([]);
    setSelectedRowsForStatsCalculation([]);
    setCurrentPage(1);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedMarket]);

  // Get current pricing options based on active button
  const plans =
    activeButton === "Monthly" ? monthlyPricingOptions : yearlyPricingOptions;

  // Mark plan as subscribed if it matches the user's active subscription
  const subscription = user?.verifiedmyTrade?.subscription;
  const hasActiveSubscription =
    subscription?.active && subscription.originalName;
  const plansWithSubscribed = plans.map((plan) => {
    if (hasActiveSubscription && plan.planType === subscription.originalName) {
      return {
        ...plan,
        subscribed: true,
        scheduledForCancellation: subscription.scheduledForCancellation,
      };
    }
    return plan;
  });

  const allPlans = [...monthlyPricingOptions, ...yearlyPricingOptions];
  const subscribedPlan = allPlans.find(
    (plan) =>
      hasActiveSubscription && plan.planType === subscription.originalName
  );

  // Handle plan button click - show confirmation popup first
  const handlePlanClick = async (plan) => {
    // If it's the subscribed plan
    if (hasActiveSubscription && plan.subscribed) {
      const action = plan.scheduledForCancellation ? "Reactivate" : "Cancel";
      setShowConfirmation({
        show: true,
        action: action,
      });
      return;
    }

    // // If user has active subscription and clicking different plan
    // if (hasActiveSubscription && !plan.subscribed) {
    //   toastify("Cancel your existing plan to change subscriptions");
    //   return;
    // }

    // New subscription - determine action
    setPendingPlan(plan);
    if (!hasActiveSubscription && !plan.subscribed) {
      setPaymentprocessing(true);
      await handleConfirmAction(plan);
    } else {
      const action = subscribedPlan
        ? Number(plan.numericPrice) > Number(subscribedPlan.numericPrice)
          ? "Upgrade"
          : "Downgrade"
        : "Subscribe";

      setShowConfirmation({
        show: true,
        action: action,
      });
    }
  };

  // Handle actual subscription action after confirmation
  const handleConfirmAction = async (subscribedPlan = false) => {
    // setPaymentprocessing(true);
    if (showConfirmation.action === "Cancel") {
      await handleConfirmCancel();
      return;
    }

    if (showConfirmation.action === "Reactivate") {
      await handleReactivate();
      return;
    }

    if (!pendingPlan && !subscribedPlan) return;

    setLoading(true);
    try {
      const res = await api("post", "users/verifyTradePaymentSubscription", {
        planType: subscribedPlan
          ? subscribedPlan.planType
          : pendingPlan.planType,
        fromOnBoarding: true,
      });
      // console.log(res,";this is a response of upgradationd and downgrdation");
      if (res?.status && res?.data?.clientSecret) {
        setPaymentStarted(true);
        setClientSecret(res.data.clientSecret);
      }
      await fetchUser(api, dispatch, storeUser);
      //  else {
      //   // console.log(res,";this is a response of upgradationd and downgrdation");
      //   toastify(res?.message || "Failed to create session");
      //   navigate("/leader/dashboard");
      // }
    } catch (error) {
      console.error("Error:", error);
      toastify("Payment failed. Please try again.");
      navigate("/leader/dashboard");
    }
    setLoading(false);
    setPaymentprocessing(false);
    setPendingPlan(null);
    setShowConfirmation({ show: false, action: "" });
  };

  // Handle reactivation after confirmation
  const handleReactivate = async () => {
    const subscription = user?.verifiedmyTrade?.subscription;
    if (!subscription?.originalName) {
      toastify("Unable to reactivate subscription");
      setShowConfirmation({ show: false, action: "" });
      return;
    }

    setLoading(true);
    try {
      const res = await api("post", "users/verifyTradePaymentSubscription", {
        planType: subscription.originalName,
        fromOnBoarding: true,
      });
      if (res?.status) {
        await getUser();
        // toastify("Subscription reactivated successfully.", "success");
      } else {
        toastify(res?.message || "Failed to reactivate subscription");
      }
    } catch (error) {
      console.error("Error:", error);
      toastify("Failed to reactivate subscription");
    } finally {
      setLoading(false);
      setPendingPlan(null);
      setPaymentprocessing(false);
      setShowConfirmation({ show: false, action: "" });
    }
  };

  // Handle actual cancellation after confirmation
  const handleConfirmCancel = async () => {
    setCancelLoading(true);
    try {
      const res = await api("post", "users/cancelBlockchainSubscription");
      if (res?.status) {
        await getUser();
        showNotificationToast(
          "You've unsubscribed!",
          "Verification has been paused."
        );
        // toastify("Subscription cancelled.", "success");
      } else {
        toastify(res?.message || "Failed to cancel subscription");
      }
    } catch (error) {
      toastify("Failed to cancel subscription");
    } finally {
      setCancelLoading(false);
      setPaymentprocessing(false);
      setShowConfirmation({ show: false, action: "" });
    }
  };

  // Handle modal close
  const handleModalClose = () => {
    setShowConfirmation({ show: false, action: "" });
    setPendingPlan(null);
  };

  // Table columns for One Time trades
  const closeTradeColumns = [
    { key: "symbol", label: "Asset", width: "180px" },
    { key: "date", label: "Date", width: "115px" },
    { key: "roiPercentage", label: "ROI (%)", width: "96px" },
    { key: "side", label: "Direction", width: "60px" },
  ];
  const openTradeColumns = [
    { key: "symbol", label: "Asset", width: "150px" },
    { key: "roiPercentage", label: "ROI (%)", width: "120px" },
    { key: "side", label: "Direction", width: "100px" },
  ];
  const tradeColumns =
    showTable === "live" ? openTradeColumns : closeTradeColumns;

  // Format table data for display
  const formatTableData = (data) => {
    if (!data || !Array.isArray(data)) return [];
    return data.map((trade, idx) => {
      const rawTime = trade?.time || trade?.timestamp;
      const dateObj = new Date(isNaN(rawTime) ? rawTime : Number(rawTime));
      const day = String(dateObj.getDate()).padStart(2, "0");
      const month = String(dateObj.getMonth() + 1).padStart(2, "0");
      const year = dateObj.getFullYear();
      const formattedDate = `${day}.${month}.${year}`;

      return {
        ...trade,
        id: trade.id || trade._id || trade.orderId || idx,
        symbol: trade?.symbol || trade?.pair,
        date: formattedDate,
        price: `$${trade.price}`,
        realizedPnl: `$${Number(trade?.realizedPnl || 0)?.toFixed(2)}`,
        commission: `$${trade.commission}`,
        pnlPercentage: `${Number(trade?.pnlPercentage || 0).toFixed(2)}%`,
        roiPercentage:`${Number(trade?.roiPercentage || 0).toFixed(2)}%`,
        qty: (trade?.qty || trade?.quantity)?.toLocaleString(),
      };
    });
  };

  // Get paginated data
  const formattedData = formatTableData(tableData);
  const paginatedData = formattedData?.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  // Calculate total pages
  const totalPages = Math.ceil((formattedData?.length || 0) / itemsPerPage);

  // Handle page change
  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handlePay = async () => {
    try {
      // setShowConfirmation({
      //   show: false,
      //   action: "",
      // });
      const res = await api("post", "users/verifyTradePaymentOneTime", {
        quantity: selectedRows?.length || 0,
        fromOnBoarding: true,
      });

      if (res?.status && res?.data?.clientSecret) {
        setClientSecret(res.data.clientSecret);
        setPaymentStarted(true);
      } else {
        toastify(res?.message || "Failed to create session");
        navigate("/leader/dashboard");
      }
    } catch (err) {
      console.error("Error:", err);
      toastify("Payment failed. Please try again.");
      navigate("/leader/dashboard");
    }
  };

  // Fetch open positions for live trades
  const callLiveTradeApi = async (market = selectedMarket) => {
    const canShowOpenTradesForMarket =
      market === "spot" ? canShowSpotOpenTrades : canShowFuturesOpenTrades;
    if (!canShowOpenTradesForMarket) {
      setLiveTableData([]);
      return;
    }

    const marketType = getMarketTypeParam(market);
    const response = await api(
      "post",
      `livetrade/getLiveTrade?marketType=${marketType}`
    );
    if (response?.data) {
      const data = response.data;
      let openPositions = data?.[0]?.openPositions || [];
      openPositions = openPositions.sort(
        (a, b) => new Date(b.updateTime) - new Date(a.updateTime)
      );
      setLiveTableData(openPositions);
    } else {
      setLiveTableData([]);
    }
  };

  useEffect(() => {
    if (showTable === "live") {
      callLiveTradeApi(selectedMarket);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showTable, selectedMarket, canShowSpotOpenTrades, canShowFuturesOpenTrades]);

  // Format live table data for display
  const formatLiveTableData = (data) => {
    if (!data || !Array.isArray(data)) return [];
    return data.map((item, idx) => ({
      ...item,
      _id: idx,
      symbol: item.symbol,
      side: item.side,
      qty: item.qty,
      pnlPercentage: `${item.pnlPercentage}%`,
      roiPercentage:`${item.pnlPercentage}%`,
      realizedPnl: `${item.pnlPercentage}%`,
    }));
  };
  const formattedLiveData = formatLiveTableData(liveTableData);

  useEffect(() => {
    if (paymentType) {
      if (paymentType === "subscription") {
        setActiveButton(
          user?.verifiedmyTrade?.subscription?.planType === "year"
            ? "Yearly"
            : "Monthly"
        );
      } else if (paymentType === "onetime") {
        setActiveButton("One Time");
        setShowTable("closed");
      }
    }
  }, [paymentType]);

  if (!paymentType) {
    navigate("/leader/verifymyTrade/tradeinfo");
    return;
  }

  async function getUser() {
    try {
      const response = await api("get", "users/index");
      if (response?.status) {
        const { data } = response;
        if (dispatch && storeUser) dispatch(storeUser(data));
        setActiveButton(
          data?.user?.verifiedmyTrade?.subscription?.planType === "year" &&
            data?.user?.verifiedmyTrade?.subscription?.status === "active"
            ? "Yearly"
            : "Monthly"
        );
        if (data?.token) localStorage.setItem("token", data.token);
      }
    } catch (err) {
      console.log(err.message);
    }
  }

  // Choose table data based on showTable
  const effectiveShowTable =
    showTable === "live" && !canShowOpenTrades ? "closed" : showTable;
  const tableDataToShow =
    effectiveShowTable === "closed" ? paginatedData : formattedLiveData;
  const allTableData =
    effectiveShowTable === "closed" ? formattedData : formattedLiveData;
  const totalTablePages =
    effectiveShowTable === "closed" ? (totalPages ? totalPages : 1) : 1;
  const currentTablePage = effectiveShowTable === "closed" ? currentPage : 1;
  const onTablePageChange =
    effectiveShowTable === "closed" ? handlePageChange : () => {};
  const noDataMessage =
    effectiveShowTable === "closed"
      ? `No ${selectedMarketLabel} trading data found`
      : `No open ${selectedMarketLabel} positions found`;

  const stylingDailyMonthly = (text) => {
    const highlighted = text
      .replace(/\bmonth\b/gi, "<span>month</span>")
      .replace(/\byear\b/gi, "<span>year</span>");
    return <span dangerouslySetInnerHTML={{ __html: highlighted }} />;
  };

  if (!paymentType) {
    return;
  }

  return (
    <div
      className={`verifyMyTradePayment ${subscribed && "d-none"}`}
      style={{
        marginTop: clientSecret && 10,
        maxWidth: clientSecret
          ? "600px"
          : activeButton === "One Time"
            ? "100%"
            : "auto",
      }}
    >
      {clientSecret ? (
        <EmbeddedCheckoutProvider
          stripe={stripePromise}
          options={{ clientSecret }}
        >
          <EmbeddedCheckout />
        </EmbeddedCheckoutProvider>
      ) : (
        <>
          {paymentType !== "onetime" ? (
            <h2 className="verifyTradeTitle">Verified Trading Payment</h2>
          ) : (
            <>
              <h2 className="verifyTradeTitle">Select trade(s)</h2>
              <p className="verifyTradeDesc">
                You can verify as many as you like
              </p>
            </>
          )}
          <div>
            {paymentType === "onetime" ? (
              <div className="verifyPaymentTradeToolbar">
                <div className="verifyPaymentMarketSelectWrap">
                  <DashboardMarketSelect />
                </div>
                <div className="switchSide p-0 justify-content-center">
                  <div style={{ padding: "4px 7px" }} className="switchBase">
                    <button
                      className={`${showTable === "closed" ? "active" : ""}`}
                      onClick={() => {
                        setShowTable("closed");
                        setSelectedRows([]);
                        setSelectedRowsForStatsCalculation([]);
                      }}
                    >
                      Closed
                    </button>
                    <button
                      className={`${showTable === "live" ? "active" : ""}`}
                      onClick={() => {
                        setShowTable("live");
                        setSelectedRows([]);
                        setSelectedRowsForStatsCalculation([]);
                      }}
                    >
                      Live
                    </button>
                  </div>
                </div>
              </div>
            ) : (
              <div className="switchSide p-0 justify-content-sm-end justify-content-center">
                <div style={{ padding: "4px 7px" }} className="switchBase">
                  <button
                    className={`${activeButton === "Monthly" ? "active" : ""}`}
                    onClick={() => setActiveButton("Monthly")}
                  >
                    Monthly
                  </button>
                  <button
                    className={`${activeButton === "Yearly" ? "active" : ""}`}
                    onClick={() => setActiveButton("Yearly")}
                  >
                    Yearly
                  </button>
                </div>
              </div>
            )}

            {/* Render pricing options for Monthly and Yearly */}
            {paymentType === "subscription" && activeButton !== "One Time" && (
              <div className="verifiedTradingPayment d-flex justify-content-center align-items-center flex-wrap">
                {plansWithSubscribed.map((option) => (
                  <Card
                    key={option.id}
                    className={`verifyTradeCard  ${
                      option.subscribed ? "verifiedSubcribedCard" : ""
                    }`}
                  >
                    {option.subscribed && (
                      <div className="subscribedTextWrap">
                        <p>Subscribed</p>
                      </div>
                    )}

                    <h4 className="storingText">{option.storing}</h4>

                    <p className="DescrpText">{option.description}</p>
                    <div className="priceBtnWrapper">
                      <p
                        className="pricingNewText"
                        dangerouslySetInnerHTML={{ __html: option.price }}
                      />
                      <div className="pricingSelectBtnWrap d-flex justify-content-center">
                        <BubbleSvgButton
                          className="verifingPaymentSelect"
                          text={
                            option.subscribed && hasActiveSubscription
                              ? option.scheduledForCancellation
                                ? "Reactivate"
                                : "Cancel"
                              : subscribedPlan
                                ? Number(option.numericPrice) >
                                  Number(subscribedPlan.numericPrice)
                                  ? "Upgrade"
                                  : "Downgrade"
                                : "Select"
                          }
                          onClick={() => handlePlanClick(option)}
                          type="button"
                          variant={
                            option.subscribed && hasActiveSubscription
                              ? "darkRed"
                              : "black"
                          }
                          containerStyling={{
                            justifyContent: "center",
                            padding: "9px 30px",
                          }}
                          disabled={
                            loading || cancelLoading || paymentprocessing
                          }
                        />
                      </div>
                    </div>
                    {/* <Form.Check
                      type="radio"
                      id={option.id}
                      className={`verifyRadioFormGroup align-items-start`}
                      name="pricing"
                      value={option.planType}
                      checked={selectedPlanType === option.planType}
                      onChange={() => handlePlanTypeChange(option.planType)}
                      label={
                        <>
                          <p className={`pricingText mb-2`}>
                            {option.price}
                            {activeButton === "Yearly" && (
                              <span className="verifyTradeCardPrice d-inline-flex align-items-center">
                                <img src={discountIcon} alt="Visa Verified" />
                                <span className="savingText">
                                  You save 2 months
                                </span>
                              </span>
                            )}
                          </p>
                        </>
                      }
                      disabled={
                        (hasActiveSubscription && !option.subscribed) ||
                        cancelLoading
                      }
                    /> */}
                  </Card>
                ))}
              </div>
            )}

            {paymentType !== "onetime" && (
              <div className="d-flex performanceDescrpWrap">
                {performanceDescrp.map((options, index) => (
                  <div className="performanceDescrpContent d-flex" key={index}>
                    <img src={greenCheck} alt="greenCheck" />
                    <p>{options}</p>
                  </div>
                ))}
              </div>
            )}

            {paymentType !== "onetime" && (
              <div className="performaceAutoTrackerTextWrap">
                <p className="performaceText">
                  Your performance is auto-tracked on the blockchain and
                  shareable via a public link. We recommend 3 months of
                  tracking. Calculations starts when you’ve subscribed. Cancel
                  or upgrade anytime.{" "}
                  <span className="d-inline-block">
                    Next billing date:{" "}
                    {activeButton === "Monthly"
                      ? getFutureDate({ months: 1 })
                      : getFutureDate({ years: 1 })}
                  </span>
                </p>
                <div
                  style={{ height: "80px", width: "116px" }}
                  className="paymentMethods"
                >
                  <p>Safe and Secure Payments Checkout</p>
                  <div
                    style={{
                      width: "84px",
                      height: "60px",
                      display: "flex",
                      justifyContent: "items-center",
                      flexWrap: "wrap",
                    }}
                    className="verifiedPaymentMethodsPartners"
                  >
                    <img
                      src={threeDSecureIcon}
                      alt="Payment Methods"
                      className="threeDSecureIcon"
                    />
                    <img
                      src={MasterCardSecureCod}
                      alt="Payment Methods"
                      style={{ width: "51px", height: "36px" }}
                      className="MasterCardSecureCod"
                    />
                    <img
                      src={VisaVerifiedGrey}
                      alt="Payment Methods"
                      style={{ width: "36px", height: "25px" }}
                      className="VisaVerifiedGrey"
                    />
                    <img
                      src={stripeIcon}
                      style={{ width: "35px", height: "14px" }}
                      alt="Payment Methods"
                      className="stripeIcon"
                    />
                  </div>
                </div>
              </div>
            )}

            {/* Button for Monthly and Yearly plans */}
            {/* {activeButton !== "One Time" && (
              <div className="formBox mt-4">
                {hasActiveSubscription ? (
                  <BubbleSvgButton
                    className="NextBtn"
                    onClick={handleCancelClick}
                    text={
                      cancelLoading ? "Cancelling..." : "Cancel Subscription"
                    }
                    type="button"
                    variant="black"
                    containerStyling={{
                      justifyContent: "center",
                    }}
                    disabled={cancelLoading}
                    mainDivStyle={{
                      width: "275px",
                      height: "55px",
                    }}
                  />
                ) : (
                  <BubbleSvgButton
                    className="NextBtn"
                    onClick={handleProceedWithPlan}
                    text="Subscribe"
                    type="button"
                    variant="black"
                    containerStyling={{
                      justifyContent: "center",
                    }}
                    disabled={!selectedPlanType}
                    mainDivStyle={{
                      width: "275px",
                      height: "55px",
                    }}
                  />
                )}
              </div>
            )} */}

            {/* Render GenericTable for One Time (closed or live) */}
            {activeButton === "One Time" && (
              <div className="verifyTradePaymentablerWrapper">
                <VerifyMyTradesTable
                  columns={tradeColumns}
                  data={tableDataToShow}
                  allData={allTableData}
                  currentPage={currentTablePage}
                  totalPages={totalTablePages}
                  onPageChange={onTablePageChange}
                  noDataMessage={noDataMessage}
                  showCheckbox={true}
                  selectedRows={selectedRows}
                  onRowSelect={handleRowSelect}
                  showSelectAllCheckbox={true}
                  onSelectAll={handleSelectAll}
                />
                <div className="formBox mt-0">
                  <BubbleSvgButton
                    className="NextBtn"
                    onClick={() => {
                      setShowConfirmation({
                        show: false,
                        action: "",
                      });
                      handlePay();
                    }}
                    text={`Pay $${selectedRows?.length} to Proceed`}
                    type="button"
                    variant="black"
                    containerStyling={{
                      justifyContent: "center",
                    }}
                    disabled={selectedRows?.length === 0}
                    mainDivStyle={{
                      width: "275px",
                      height: "55px",
                    }}
                  />
                </div>
              </div>
            )}
            <div className="verifyMyTradePaginationDots paginationDots">
              <button className="dot"></button>
              <button className="dot"></button>
              <button className="dot active"></button>
            </div>
          </div>
        </>
      )}

      {/* Confirmation Modal */}
      <Modal
        backdrop="false"
        id="verificationApiModal"
        show={showConfirmation.show}
      >
        <Modal.Body>
          <div className="modalContent">
            <Button className="closeBtn" onClick={handleModalClose}>
              <img alt="Close Modal" src={cross} />
            </Button>
            <div className="regBox" style={{ gap: "13px" }}>
              <div className="img-box">
                <img
                  alt="Confirmation"
                  src={tradeBellPng}
                  className="bellIconSvg"
                />
              </div>
              <div className="content-box">
                <p className="popUpMsg">
                  {showConfirmation.action === "Cancel"
                    ? "Cancel your subscription?"
                    : showConfirmation.action === "Reactivate"
                      ? "Reactivate your subscription?"
                      : showConfirmation.action === "Upgrade"
                        ? "Upgrade your subscription?"
                        : showConfirmation.action === "Downgrade"
                          ? "Downgrade your subscription?"
                          : "Subscribe to this plan?"}
                  <br />
                  {showConfirmation.action === "Cancel" && (
                    <span>Copy trading will be interrupted.</span>
                  )}
                  {showConfirmation.action === "Reactivate" && (
                    <span>Your subscription will continue as normal.</span>
                  )}
                  {showConfirmation.action === "Downgrade" && (
                    <span>
                      Your plan will be updated at the start of your next
                      billing period.
                    </span>
                  )}
                  {showConfirmation.action === "Upgrade" && (
                    <span>
                      Your plan updates immediately, with a credit for your
                      current monthly payment.
                    </span>
                  )}
                  {showConfirmation.action === "Subscribe" && (
                    <span>Your subscription will be updated accordingly.</span>
                  )}
                </p>
              </div>
            </div>
            <div className="payoutButtonBox">
              <BubbleSvgButton
                className="payoutModalBtn"
                mainDivStyle={{ width: "126px", height: "36px" }}
                text={"Continue"}
                type="button"
                variant="black"
                containerStyling={{
                  justifyContent: "center",
                }}
                onClick={async () => {
                  setShowConfirmation({
                    show: false,
                    action: "",
                  });
                  setPaymentprocessing(true);
                  await handleConfirmAction();
                }}
                disabled={loading || cancelLoading}
              />
              <BubbleSvgButton
                className="payoutModalBtn"
                mainDivStyle={{ width: "126px", height: "36px" }}
                text={"Cancel"}
                type="button"
                variant="red"
                containerStyling={{
                  justifyContent: "center",
                }}
                onClick={handleModalClose}
              />
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default VerifyMyTradePayment;
